import { Grid, UI } from 'common';
import PropTypes from 'prop-types';
import React from 'react';
import DateCellRenderer from '../shared/DateCellRenderer.component';

const { GridPanel } = Grid;
const { WrappedButton, WrappedButtonType } = UI;

const usCurrencyFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
});

const NetStampsRefundContent = ({
	mailInPrints = null,
	onSelectionChanged,
	totalCost,
	selectedPrintsForRefund,
}) => {
	const { labelDetails = {} } = mailInPrints;

	const columnDefs = [
		{
			field: 'row',
			headerName: 'Row #',
			type: 'numericColumn',
			width: 100,
			headerCheckboxSelection: true,
			checkboxSelection: true,
			sort: 'desc',
			sortable: false,
		},
		{
			field: 'column',
			headerName: 'Column #',
			type: 'numericColumn',
			width: 100,
			sort: 'desc',
			sortable: false,
		},
		{
			field: 'amount',
			headerName: 'Cost',
			width: 100,
			cellRenderer({ value }) {
				return value;
			},
			sortable: false,
		},
		{
			field: 'serviceTypeName',
			flex: 1,
			headerName: 'Mail Class',
			width: 150,
			sortable: false,
		},
		{
			field: 'dateCreated',
			headerName: 'Print Date',
			width: 120,
			cellRenderer: 'DateCellRenderer',
			sort: 'desc',
			sortable: false,
		},
	];

	const { netstampDetails } = labelDetails;

	const getNetstampDetails = () =>
		netstampDetails.map(netstampDetail => {
			netstampDetail.serviceTypeName =
				selectedPrintsForRefund[0].printDetails.serviceTypeName;
			netstampDetail.dateCreated =
				selectedPrintsForRefund[0].printDetails.shipDate;
			return netstampDetail;
		});

	return (
		<div className="history-refund netstamps-refund-content">
			<h3>Select Netstamps to Refund</h3>
			<p>
				Please select which NetStamps you will be mailing to Stamps.com with
				your refund claim.
			</p>
			<GridPanel
				className="grid"
				columnDefs={columnDefs}
				defaultColDef={{
					suppressSizeToFit: true,
					suppressMovable: true,
					suppressMenu: true,
				}}
				domLayout="autoHeight"
				frameworkComponents={{ DateCellRenderer }}
				onSelectionChanged={onSelectionChanged}
				rowData={getNetstampDetails()}
				showPagination={false}
			/>
			<div className="total">
				<p>Total Request: {usCurrencyFormatter.format(totalCost)}</p>
			</div>
		</div>
	);
};

NetStampsRefundContent.propTypes = {
	mailInPrints: PropTypes.object,
	onSelectionChanged: PropTypes.func.isRequired,
	totalCost: PropTypes.number,
};

export default NetStampsRefundContent;
